"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookmlModelNavExploreDto = void 0;
class LookmlModelNavExploreDto {
    constructor(lookmlModelNavExploreDto, modelName) {
        this.name = lookmlModelNavExploreDto.name;
        this.description = lookmlModelNavExploreDto.description;
        this.label = lookmlModelNavExploreDto.label;
        this.hidden = lookmlModelNavExploreDto.hidden;
        this.groupLabel = lookmlModelNavExploreDto.group_label;
        this.modelName = modelName;
    }
    static get QUERY_FIELDS() {
        return 'name,description,label,hidden,group_label';
    }
}
exports.LookmlModelNavExploreDto = LookmlModelNavExploreDto;
